import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AppState } from 'src/store/store';
import { QuotaCategoriesPageState } from 'src/pages/quotaCategories/types';
import guidesApiService from 'src/api/services/guidesApiService';
import { notification } from 'antd';

const initialState: QuotaCategoriesPageState = {
    isLoading: false,
    items: [],
    requestId: ''
};

export const loadQuotaCategoriesAsync = createAsyncThunk('quotaCategories/load', async () => {
    try {
        const data = await guidesApiService.getQuotaCategories();
        return data;
    } catch (error) {
        if (error instanceof Error) {
            notification.error({ message: error.message });
        }
        throw new Error();
    }
});

const slice = createSlice({
    name: 'quotaCategories',
    initialState,
    reducers: {
        reset: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadQuotaCategoriesAsync.pending, (state, action) => {
                state.isLoading = true;
                state.items = [];
                state.requestId = action.meta.requestId;
            })
            .addCase(loadQuotaCategoriesAsync.fulfilled, (state, action) => {
                if (state.requestId === action.meta.requestId) {
                    state.isLoading = false;
                    state.items = action.payload;
                }
            })
            .addCase(loadQuotaCategoriesAsync.rejected, (state, action) => {
                if (state.requestId === action.meta.requestId) {
                    state.isLoading = false;
                }
            });
    }
});

export const { reset } = slice.actions;

const selectQuotaCategories = (state: AppState) => state.quotaCategories;

export const selectItems = (state: AppState) => selectQuotaCategories(state).items;

export const selectIsLoading = (state: AppState) => selectQuotaCategories(state).isLoading;

export default slice.reducer;
